import { selectSuperAgentLevelInfo } from 'shared/selectors';

import { IState } from '../../../store';

export const selectHasVerifiedDocuments = (state: IState): boolean => {
  const superAgentLevelInfo = selectSuperAgentLevelInfo(state);

  if (superAgentLevelInfo) {
    const { hasVerifiedDocuments, levelOrder = 0 } = superAgentLevelInfo;

    return !!hasVerifiedDocuments && levelOrder < 4;
  }

  return !!state.offerData.agent?.moderationInfo?.isUserIdentifiedByDocuments;
};
